<template>
    <div class="Course">
        <h2>Sessions <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Trainer:</label>
                        <select class="form-control" v-model="Filters.Trainer" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option v-for="trainer in TrainerList" v-bind:value="trainer">{{ trainer }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Modality:</label>
                        <select class="form-control" v-model="Filters.Modality" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="Webinar">Webinar</option>
                            <option value="In-Person">In-Person</option>
                            <option value="Virtual">Virtual</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Course:</label>
                        <select class="form-control" v-model="Filters.CourseName" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option v-for="course in CourseList" v-bind:value="course.Name">{{ course.Name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Date:</label>
                        <select class="form-control" v-model="Filters.Date" @change="RefreshDataTable">
                            <option value="All">All</option>
                            <option value="Upcoming">Upcoming</option>
                            <option value="Prior">Prior</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Region:</label>
                        <select class="form-control" v-model="Filters.Region" @change="RefreshDataTable">
                            <option v-if="CheckPermission('CanAccessAllOptionInSubPrograms')" value="All">All</option>
                            <option v-for="region in UserPrivateProfile.Region" v-if="region != null" v-bind:value="region">{{ region }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Search Sessions:</label>
                        <input type="text" v-model="search" class="form-control" @input="RedrawTable()" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    Displaying {{NumberOfClients}} Records
                </div>
            </div>
            <div class="row">
                <div class="col-sm-4">
                    <b-button @click="OpenAddSessionModal()" variant="olive-green" style="margin-bottom:1rem;"> Add Session</b-button>
                </div>
            </div>
        </form>
        <div style="overflow-x:auto">
            <vuetable :fields="SessionTableOptions.Fields"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      :data-manager="DataManager"
                      ref="datatable">

                <template slot="Attend" scope="props">
                    <div class="AttendDiv">
                        <b-row no-gutters>
                            <b-col md="auto">
                                <b-button variant="olive-green" @click="OpenAttendModal(props.rowData)">
                                    <span>
                                        Sign Up or Sign Up Others
                                    </span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </template>
                <template slot="ViewAttendees" scope="props">
                    <div class="ViewAttendeesDiv">
                        <b-row no-gutters>
                            <b-col md="auto">
                                <b-button @click="ViewAttendeesModal(props.rowData)" variant="link">
                                    <span>
                                        {{props.rowData.Attendees.length}}/{{props.rowData.MaxAttendees}}
                                    </span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </template>
                <template slot="SessionPhoto" scope="props">
                    <div class="SessionPhotoDiv">
                        <b-row no-gutters>
                            <b-col md="auto" class="olive-green-text">
                                <font-awesome-icon @click="OpenSessionPhotoModal(props.rowData)" style="font-size: 30px;" :icon="['fa', 'image']" class="pointer" />

                            </b-col>
                        </b-row>
                    </div>
                </template>
                <template slot="SessionActions" scope="props">
                    <div class="SessionActionsDiv">
                        <b-row no-gutters>
                            <b-col md="auto">
                                <font-awesome-icon :icon="['fa', 'edit']" style="font-size: 20px; margin-right:0.5rem;" class="pointer orange " @click="UpdateSessionModal(props.rowData)" />
                                <ActionButtonWithIcon :requires-confirmation="true"
                                          confirmation-string="WARNING: You are about to delete this session.  Are you sure?"
                                          endpoint="Training/DeleteSession"
                                          :payload="{Id: props.rowData.Id}"
                                          :perform-global-update="false"
                                          button-variant="success"
                                          button-string=""
                                          button-size="md"
                                          emit-on-success="role-deleted"
                                          v-on:success="RefreshDataTable" 
                                          icon-prefix="fa"
                                          icon-suffix="trash-alt"
                                          icon-color="red"
                                          method="POST"/>
                            </b-col>
                        </b-row>
                    </div>
                </template>
                <template slot="DetailButton" scope="props">
                    <div class="pointer" @click="onCellClicked(props.rowData)">
                        <span class="underline pointer"> <font-awesome-icon :icon="['fa', 'caret-down']" class="pointer" /></span>
                    </div>
                </template>
            </vuetable>
        </div>
        <b-modal ref="add-session-modal" title="Add Session" hide-footer>
            <b-container fluid>
                <b-form @submit="AddSession">
                    <b-row>
                        <b-col cols="12"><b>Course:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="SessionForm.CourseID">
                                <option v-for="course in CourseList" v-bind:value="course.Id">{{ course.Name }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Trainer:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="SessionForm.Trainer" type="name" required></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Location:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="SessionForm.Location" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Modality:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="SessionForm.Modality" required>
                                <option value="Webinar">Webinar</option>
                                <option value="In-Person">In-Person</option>
                                <option value="Virtual">Virtual</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Date and Time:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="SessionForm.StartDate" :config="DateConfig" required></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Max Attendees:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="SessionForm.MaxAttendees" type="number" required></b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal('add-session-modal')">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="update-session-modal" title="Update Session" hide-footer>
            <b-container fluid>
                <b-form @submit="UpdateSession">
                    <b-row>
                        <b-col cols="12"><b>Course:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="UpdateSessionForm.CourseID">
                                <option v-for="course in CourseList" v-bind:value="course.Id">{{ course.Name }}</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Trainer:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateSessionForm.Trainer" type="name" required></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12"><b>Location:</b></b-col>
                    </b-row>
                    <b-row no-gutters="true">
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateSessionForm.Location" type="name" required></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Modality:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <select class="form-control" v-model="UpdateSessionForm.Modality" required>
                                <option value="Webinar">Webinar</option>
                                <option value="In-Person">In-Person</option>
                                <option value="Virtual">Virtual</option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Date and Time:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem">
                            <flat-pickr class="form-control" v-model="UpdateSessionForm.StartDate" :config="DateConfig" required></flat-pickr>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12"><b>Max Attendees:</b></b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" style="margin-bottom: 1rem"><b-form-input v-model="UpdateSessionForm.MaxAttendees" type="number" required></b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelModal('update-session-modal')">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="attend-modal" @hide="HideAttendModal()" title="Sign Up or Sign Up Others to this Session" hide-footer>
            <b-container fluid>
                <b-form @submit="AddAttendees">
                    <!--<b-row>
                        <b-col cols="12"><b-button variant="success" @click="AttendSelf">Attend {{AttendForm.CourseName}}</b-button></b-col>
                    </b-row>-->
                    <b-row style="overflow-y:auto;max-height:50vh;">
                        <div>
                            <b-form-group>
                                <div v-for="(subProgram,index) in SubProgramList" v-if="subProgram.Name != null">
                                    <b-form-checkbox v-model="subProgramSelected.allSelected[subProgram.Id]"
                                                     :indeterminate="indeterminateComputed[subProgram.Id]"
                                                     aria-describedby="selected"
                                                     aria-controls="selected"
                                                     size="lg"
                                                     @change="toggleAll(subProgramSelected.allSelected[subProgram.Id],subProgram.Id)">
                                        {{indeterminate[subProgram.Id]}}
                                        <b>{{subProgram.Name}}</b>
                                    </b-form-checkbox>
                                        <b-form-checkbox v-for="user in UserList"
                                                         v-if ="user.SubProgramID == subProgram.Id"
                                                         v-model="user.Checked"
                                                         :key="user.FullName"
                                                         :value="true" :unchecked-value="false"
                                                         size="lg"
                                                         name="flavour-3a"
                                                         style="margin-left:1rem;">
                                            <span>{{ user.FullName }}</span>
                                        </b-form-checkbox>
                                    
                                </div>
                            </b-form-group>

                        </div>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="HideAttendModal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <b-modal ref="view-attendees-modal" size="lg" @hide="RefreshDataTable" hide-footer>
            <template #modal-title="{  }">
                <div v-if="ViewAttendeesForm.Session != ''">
                    {{ViewAttendeesForm.Session.Course.Name}}<br /> {{formatDateMonthDayYear(ViewAttendeesForm.Session.StartDate)}}
                </div>
                <div v-else>
                    Attendees
                </div>
            </template>
            <b-container fluid>
                <vuetable :fields="AttendeeTableOptions.Fields"
                          pagination-path=""
                          :api-mode="false"
                          class="vue-datatable"
                          :data="SessionAttendeeList"
                          ref="datatableAttendee">
                    <template slot="AttendeeActions" scope="props">
                        <div class="AttendeeActionsDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <b-form style="display:none;" :ref="'uploadCertificateFile' + props.rowData.Id" class="custom-file-upload">
                                        <b-form-group>
                                            <b-form-file ref="certificateFileRef"
                                                            v-model="AttendForm.CertificateFile[props.rowData.Id]"
                                                            @change="AddOrRemoveCertificateFile(props.rowData)"
                                                            name="CertificateFile"
                                                            accept="application/pdf"
                                                            :id="'certificateFileRefID' + props.rowData.Id">
                                            </b-form-file>
                                        </b-form-group>
                                    </b-form>
                                    <span v-if="props.rowData.CertificateFile != null">
                                        <span v-b-tooltip.hover title="View Certificate File">
                                            <font-awesome-icon v-on:click="ViewDocument(props.rowData.CertificateFileID, props.rowData.CertificateFile.Name,props.rowData.CertificateFile.Name)" :icon="['fa', 'file-pdf']" style="font-size: 20px; margin-right:0.5rem;" class="pointer green" ></font-awesome-icon>
                                        </span>
                                        <span @click="PopulateFormData(props.rowData)" v-b-tooltip.hover title="Remove Certificate File">
                                            <ActionButtonWithIcon 
                                                                  :requires-confirmation="true"
                                                                  confirmation-string="WARNING: You are about to delete this certificate file.  Are you sure?"
                                                                  endpoint="Training/DeleteCertificateFile"
                                                                  :payload="DeleteCertificateFileFromData"
                                                                  :perform-global-update="false"
                                                                  button-variant="success"
                                                                  button-string=""
                                                                  button-size="md"
                                                                  v-on:success="DeleteCertificateFileResponse"
                                                                  icon-prefix="fa"
                                                                  icon-suffix="ban"
                                                                  icon-color="red" 
                                                                  method="POST"/>
                                        </span>
                                    </span>
                                    <span v-else  v-b-tooltip.hover title="Add Certificate File">
                                        <font-awesome-icon @click="openFileDir(props.rowData.Id)" :icon="['fa', 'file-pdf']" style="font-size: 20px; margin-right:0.5rem;" class="pointer red "></font-awesome-icon>
                                    </span>
                                    <span v-b-tooltip.hover title="Remove attendee">
                                        <ActionButtonWithIcon :requires-confirmation="true"
                                                              confirmation-string="WARNING: You are about to delete this attendee.  Are you sure?"
                                                              endpoint="Training/DeleteAttendee"
                                                              :payload="{Id: props.rowData.Id}"
                                                              :perform-global-update="false"
                                                              button-variant="success"
                                                              button-string=""
                                                              button-size="md"
                                                              emit-on-success="role-deleted"
                                                              v-on:success="DeleteAttendeeReponse"
                                                              icon-prefix="fa"
                                                              icon-suffix="trash-alt"
                                                              icon-color="red"
                                                              method="POST"/>
                                    </span>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                    <template slot="AttendeeStatus" scope="props">
                        <div class="AttendeeStatusDiv">
                            <b-row no-gutters>
                                <b-col md="auto">
                                    <select class="form-control" v-model="AttendeeEdit.Status[props.rowData.Id]" @change="UpdateStatus(props.rowData)" crequired>
                                        <option value="Scheduled">Scheduled</option>
                                        <option value="Completed">Completed</option>
                                        <option value="Canceled">Canceled</option>
                                        <option value="Failed">Failed</option>
                                    </select>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </vuetable>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelModal('view-attendees-modal')">
                            Close
                        </b-button>
                        <b-button size="md" variant="primary" @click="ScheduledToCompleteStatusAttendee()">
                            Complete All Scheduled
                        </b-button>
                    </div>
                </b-row>
            </b-container>
        </b-modal>
        <b-modal ref="session-photo-modal" size="lg" title="View Session Photos" hide-footer>
            <b-container fluid>
                <b-form @submit="AddSessionPhoto">
                    <b-row>
                        <b-col cols="12">
                            <b-form ref="uploadFile">
                                <b-form-group label="Add Session Photos.">
                                    <b-form-file drop-placeholder="Drop image here..."
                                                 name="File"
                                                 accept=".jpg, .png"
                                                 class="form-control" multiple />
                                </b-form-group>
                            </b-form>
                        </b-col>
                    </b-row>
                    <b-row v-for="(photos,index) in SessionPhotos">
                        <b-col cols="11">
                            <img v-bind:src="SessionPhotoImages(index)" style="width:100%; max-width:2400px;" />
                        </b-col>
                        <b-col v-if="EditMode" cols="1">
                            <ActionButtonWithIcon :requires-confirmation="true"
                                      confirmation-string="WARNING: You are about to delete this image.  Are you sure?"
                                      endpoint="Training/DeleteSessionPhoto"
                                      :payload="{Id: SessionPhotos[index].Id}"
                                      :perform-global-update="false"
                                      button-variant="success"
                                      button-string=""
                                      button-size="md"
                                      emit-on-success="GetSessionPhotos"
                                      v-on:success="GetSessionPhotos"
                                      icon-prefix="fa"
                                      icon-suffix="trash-alt"
                                      icon-color="red"
                                      method="POST"/>
                        </b-col>
                    </b-row>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" />
                            <b-button size="md" variant="secondary" @click="CancelModal('session-photo-modal')">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="primary" type="submit">
                                CONFIRM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>
        <DocumentViewer ref="document-viewer-modal-component" :reviewing="false" />
    </div>
</template>

<script>
    //import services
    //import { ClientsAPI } from '../../../services/api/Foster/ClientsAPI.js';

    //import components
    //import ChildListDetailRow from './ChildListDetailRow'
    //import Vue from 'vue';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import ActionButtonWithIcon from '../Admin/ActionButtonWithIcon.vue';
    import EditMode from '../Core/ItemEditors/EditMode.vue';
    import DocumentViewer from "../Core/RecordComponents/DocumentViewer.vue";
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
    library.add(faFilePdf);
    import { faBan } from '@fortawesome/free-solid-svg-icons';
    library.add(faBan);
    import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
    library.add(faCaretDown);
    import { faImage } from '@fortawesome/free-solid-svg-icons';
    library.add(faImage);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { EventBus } from '../../services/event-bus.js';
    export default {
        created() {
            //this.$store.commit("Clients.ClientProfiles.Clear");
            //this.$store.commit("Clients.ClientEnrollmentsList.Clear");
            //const clientsAPI = new ClientsAPI(this.$baseURL);
            //this.clientsAPI = clientsAPI;
        },
        props: [],
        data: function () {
            return {
                NumberOfClients: '',
                search: "",
                SessionList: [],
                CourseList: [],
                UserList: [],
                selected: [],
                indeterminate: [],
                AttendeeList: [],
                SubProgramList: [],
                SessionPhotos: [],
                EditMode: false,
                TrainerList: [],
                SessionAttendeeList: [],
                DeleteCertificateFileFromData: '',
                subProgramSelected: {
                    allSelected:[]
                },
                imageFile: null,
                SessionForm: {
                    //Id:'',
                    Location: '',
                    Modality: '',
                    StartDate: '',
                    Trainer: '',
                    MaxAttendees: '',
                    CourseID: ''
                },
                UpdateSessionForm: {
                    //Id:'',
                    Location: '',
                    Modality: '',
                    StartDate: '',
                    Trainer: '',
                    MaxAttendees: '',
                    CourseID: ''
                },
                AttendForm: {
                    CourseName: '',
                    SessionName: '',
                    SessionID: '',
                    Session: '',
                    Status: '',
                    EmployeeIDs: '',
                    CertificateFileID: null,
                    CertificateFile: []
                },
                AttendeeEdit: {
                    Status: {}
                },
                SessionPhotoForm: {
                    //Id:'',
                    File: '',
                    SessionID: ''
                },
                ViewAttendeesForm: {
                  Session: ''
                },
                Filters: {
                    Modality: "All",
                    CourseName: "All",
                    Trainer: "All",
                    Date: "Upcoming",
                    Region: ""
                },
                CourseFilters: {
                    Level: "All",
                    Region: "All",
                    ExpirationDate: null,
                    Category: "All"
                },
                SessionTableOptions: {
                    Fields: [
                        {
                            name: 'Course.Name',
                            title: 'Course Name',
                            sortField: 'Course.Name'
                        },
                        {
                            name: 'Course.Region',
                            title: 'Region',
                            sortField: 'Course.Region'
                        },
                        {
                            name: 'Location',
                            title: 'Location',
                            sortField: 'Location'
                        },
                        {
                            name: 'Modality',
                            title: 'Modality',
                            sortField: 'Modality'
                        },
                        {
                            name: 'StartDate',
                            title: 'Start Date',
                            sortField: 'StartDate',
                            callback: 'formatDate|MM/DD/YY hh:mm A'
                        },
                        {
                            name: 'Trainer',
                            title: 'Trainer',
                            sortField: 'Trainer'                            
                        },
                        {
                            name: '__slot:ViewAttendees',
                            title: 'Attendees',
                            sortField: 'MaxAttendees'
                        },
                        {
                            name: '__slot:SessionPhoto',
                            title: 'Photos',
                        },
                        {
                            name: '__slot:Attend',
                            title: 'Attend'
                        },
                        {   
                            name: '__slot:SessionActions',
                            title: 'Actions'
                        }
                    ]
                },
                AttendeeTableOptions: {
                    Fields: [
                        {
                            name: 'Employee.Person.FullName',
                            title: 'Name',
                            sortField: 'Employee.Person.FullName'
                        },
                        {
                            name: '__slot:AttendeeStatus',
                            title: 'Status',
                            sortField: 'Status'
                        },
                        {
                            name: '__slot:AttendeeActions',
                            title: 'Actions'
                        },
                    ]
                },
                DateConfig: {
                    dateFormat: 'Y-m-d G:i K',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y G:i K',
                    required: false,
                    enableTime: true
                },
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetSessions();

            },
            AddSession(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddSession", this.SessionForm, this.AddSessionSuccess, () => { }, true);
            },
            AddSessionSuccess(response) {
                this.GetSessions();
                this.$refs["add-session-modal"].hide();
            },
            UpdateSession(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Training/UpdateSession", this.UpdateSessionForm, this.UpdateSessionSuccess, () => { }, true);
            },
            UpdateSessionSuccess(response) {
                this.GetSessions();
                this.$refs["update-session-modal"].hide();
            },
            GetSessions() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetSessions", this.Filters, this.GetSessionsSuccess, () => { }, true);
            },
            GetSessionsSuccess(response) {
                let vm = this;
                this.SessionList = response.data.data;
                vm.SessionList.forEach(function (session) {
                    //if trainerlist does not include the trainer, add it
                    if (!vm.TrainerList.includes(session.Trainer)) {
                        vm.TrainerList.push(session.Trainer);
                    }
                });
                vm.$refs.datatable.refresh();
            },
            AttendSelf() {
                //clear array
                this.selected = [];
                //set selected to ur employee id
                this.selected[0] = this.UserPrivateProfile.EmployeeID;
                this.AttendForm.EmployeeIDs = this.selected;
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddAttendees", this.AttendForm, this.AttendSelfSuccess, () => { }, true);
            },
            AttendSelfSuccess(response) {
                this.$refs.datatable.refresh();
                this.$refs["attend-modal"].hide();
            },
            AddAttendees(e) {
                e.preventDefault();
                let output = {
                    'EmployeeIDs': [], 'Session': {}, 'SessionID' : ''}
                for (var i = 0; i < this.UserList.length; i++) {
                    if (this.UserList[i].Checked == true) {
                        output.EmployeeIDs.push(this.UserList[i].EmployeeID)
                    } 
                }
                output.Session = this.AttendForm.Session;
                output.SessionID = (this.AttendForm.SessionID);
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddAttendees", output, this.AddAttendeesSuccess, () => { }, false);
            },
            AddAttendeesSuccess(response) {
                this.RefreshDataTable();
                this.GetUsers();
                //clear this.AttendForm.EmployeeIDs array
                this.AttendForm.EmployeeIDs = []
                this.$refs["attend-modal"].hide();
            },
            ScheduledToCompleteStatusAttendee() {
                var AttendeeIDs = [];
                this.SessionAttendeeList.forEach(function (attendee) {
                    AttendeeIDs.push(attendee.Id)
                });
                //this.AttendForm.EmployeeIDs = this.selected;
                this.$MasterAPI.ExecuteRequest("POST", "Training/ScheduledToCompleteStatusAttendee", { AttendeeIDs: AttendeeIDs }, this.ScheduledToCompleteStatusAttendeeSuccess, () => { }, true);
            },
            ScheduledToCompleteStatusAttendeeSuccess(response) {
                this.ViewAttendeesModal(response.data.data, false);
            },
            AddSessionPhoto(e) {
                e.preventDefault();
                let form = this.$refs['uploadFile'];
                let formData = new FormData(form);
                formData.append("File", this.SessionPhotoForm.File);
                formData.append("SessionID", this.SessionPhotoForm.SessionID);
                this.AttendForm.EmployeeIDs = this.selected;
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddSessionPhoto", formData, this.AddSessionPhotoSuccess, () => { }, true);
            },
            AddSessionPhotoSuccess(response) {
                this.$refs.datatable.refresh();
                this.$refs["session-photo-modal"].hide();
            },
            PopulateFormData(rowData) {
                let vm = this;
                let form = this.$refs['uploadCertificateFile' + rowData.Id];
                let formData = new FormData(form);
                formData.append("CertificateFile", vm.AttendForm.CertificateFile[rowData.Id]);
                formData.append("Id", rowData.Id);
                this.DeleteCertificateFileFromData = formData;
            },
            DeleteCertificateFileResponse(response) {
                //EventBus.$emit('refresh-table')
                   this.ViewAttendeesModal(response, false);
            },
            DeleteAttendeeReponse(response) {
                this.GetUsers();
                this.ViewAttendeesModal(response, false);
            },
            refreshTable() {
                this.$refs.datatableAttendee.resetData();
            },
            AddOrRemoveCertificateFile(rowData) {
                let form = this.$refs['uploadCertificateFile' + rowData.Id];
                let formData = new FormData(form);
                formData.append("CertificateFile", this.AttendForm.CertificateFile[rowData.Id]);
                formData.append("Id", rowData.Id);
                this.$MasterAPI.ExecuteRequest("POST", "Training/AddOrRemoveCertificateFile", formData, this.AddOrRemoveCertificateFileSuccess, () => { }, true);
            },
            AddOrRemoveCertificateFileSuccess(response) {
                this.GetSessions();
                let vm = this;
                //clear form;
                this.AttendForm.CertificateFile[rowData.Id] = null;
                for (var i = 0; i < vm.SessionAttendeeList.length; i++) {
                    if (vm.SessionAttendeeList[i].Id == response.data.data.Id) {
                        vm.$set(vm.SessionAttendeeList, i, response.data.data);
                        break;
                    }
                }
            },
            GetCourses() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetCourses", this.CourseFilters, this.GetCoursesSuccess, () => { }, true);
            },
            GetCoursesSuccess(response) {
                this.CourseList = response.data.data;
                this.$refs.datatable.refresh();
            },
            GetAttendees() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetAttendees", {}, this.GetAttendeesSuccess, () => { }, true);
            },
            GetAttendeesSuccess(response) {
                this.AttendeeList = response.data.data;
                this.$refs.datatable.refresh();
            },
            GetUsers() {
                let usersSubPrograms = [];
                this.UserPrivateProfile.AssignedSubPrograms.forEach(function (subprogram) {
                    usersSubPrograms.push(subprogram.Id);
                });
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetUsers", { EmployeeID: this.UserPrivateProfile.EmployeeID, UserID: this.UserPrivateProfile.UserId }, this.GetUsersSuccess, () => { }, true);
            },
            GetUsersSuccess(response,usersSubPrograms) {
                this.UserList = response.data.data;
                usersSubPrograms = [];
            },
            GetSubPrograms() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetSubPrograms", { EmployeeID: this.UserPrivateProfile.EmployeeID, UserID: this.UserPrivateProfile.UserId }, this.GetSubProgramsSuccess, () => { }, true);
            },
            GetSubProgramsSuccess(response) {
                this.SubProgramList = response.data.data;
                this.Filters.Region = this.UserPrivateProfile.Permissions.includes("Administrator") ? "All" : this.SubProgramList[0].Region;
                this.GetSessions();
            },
            GetSessionPhotos() {
                this.$MasterAPI.ExecuteRequest("GET", "Training/GetSessionPhotos", { Id: this.SessionPhotoForm.SessionID }, this.GetSessionPhotosSuccess, () => { }, true);
            },
            GetSessionPhotosSuccess(response) {
                this.SessionPhotos = response.data.data;
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
            RedrawTable() {
                this.$refs.datatable.refresh();
            },
            DataManager(sortOrder, pagination) {
                let dataset = this.filteredList(this.SessionList);
                if (dataset.length > 0) {
                    if (sortOrder.length > 0) {
                        if (sortOrder[0].direction == 'asc') {
                            var firstComp = 1;
                            var secondComp = -1;
                        } else {
                            var firstComp = -1;
                            var secondComp = 1
                        }
                        return dataset.sort((a, b) => (this.$FindProperty(a, sortOrder[0].sortField) > this.$FindProperty(b, sortOrder[0].sortField)) ? firstComp : secondComp);
                    } else {
                        return dataset;
                    }

                } else {
                    return [];
                }
            },
            filteredList(inputData) {
                let vm = this;
                let tData = inputData
                if (tData == null) {
                    return [];
                }
                let tFields = vm.$refs["datatable"].tableFields;
                let visibleData = [];
                tData.forEach(function (row, index) {
                    let rowData = [];
                    tFields.forEach(function (field) {
                        rowData.push(vm.$refs.datatable.renderNormalField(field, row));

                    })
                    if (vm.search == "" || JSON.stringify(rowData).toLowerCase().includes(vm.search.toLowerCase())) {
                        visibleData.push(inputData[index]);
                    }
                });
                this.NumberOfClients = visibleData.length;
                return visibleData;
            },
            ViewDocument(pdfFileID, formLabel, documentName) {
                this.$refs['document-viewer-modal-component'].ShowViewerModal(pdfFileID, formLabel, documentName);
            },
            OpenAddSessionModal() {
                this.GetCourses();
                this.SessionForm.Location = "";
                this.SessionForm.Modality = "";
                this.SessionForm.StartDate = "";
                this.SessionForm.Trainer = "";
                this.SessionForm.MaxAttendees = "";
                this.SessionForm.CourseID = "";
                this.$refs["add-session-modal"].show();
            },
            OpenAttendModal(rowData) {
                this.AttendForm.CourseName = rowData.Course.Name;
                this.AttendForm.SessionID = rowData.Id;
                this.AttendForm.Session = rowData;
                this.UserList.forEach(function (user) {
                    if (user.SessionIDs.length > 0 && user.SessionIDs.includes(rowData.Id)) {
                        user.Checked = true;
                    }
                    else {
                        user.Checked = false;
                    }
                });
                this.$refs["attend-modal"].show();

            },
            HideAttendModal() {
                this.$refs["attend-modal"].hide();
                this.selected = [];
            },
            HideViewAttendModal() {
                this.$refs["view-attendees-modal"].hide();
                this.GetSessions();
            },
            UpdateAttendeeModal(rowData) {
                this.AttendForm.Status = rowData.Status;
                this.$refs["update-attendee-modal"].show();
            },
            OpenSessionPhotoModal(rowData) {
                this.SessionPhotoForm.SessionID = rowData.Id;
                this.GetSessionPhotos();
                this.$refs["session-photo-modal"].show();
            },
            ViewAttendeesModal(rowData, showModal = true) {
                this.ViewAttendeesForm.Session = rowData;
                this.SessionAttendeeList = rowData.Attendees;
                let vm = this;
                this.AttendeeEdit["Status"] = {};
                rowData.Attendees.forEach(function (attendee) {
                    vm.AttendeeEdit.Status[attendee.Id] = attendee.Status;
                });
                if (showModal) {
                    this.$refs["view-attendees-modal"].show();
                }
                
            },
            RefreshViewAttendeeTable(SessionID) {
               
                let vm = this;
                this.GetSessions();
                for (var i = 0; i < vm.SessionList.length; i++) {
                    if (vm.SessionList[i].Id == SessionID) {
                        vm.SessionAttendeeList = vm.SessionList[i].Attendees;
                        vm.$refs.datatableAttendee.refresh();
                        break;
                    }
                }
            },
            openFileDir(Id) {
                var elem = document.getElementById("certificateFileRefID" + Id);
                elem.click();
            },
            UpdateSessionModal(rowData) {
                this.UpdateSessionForm.Id = rowData.Id;
                this.UpdateSessionForm.Location = rowData.Location;
                this.UpdateSessionForm.Modality = rowData.Modality;
                this.UpdateSessionForm.StartDate = rowData.StartDate;
                this.UpdateSessionForm.Trainer = rowData.Trainer;
                this.UpdateSessionForm.MaxAttendees = rowData.MaxAttendees;
                this.UpdateSessionForm.CourseID = rowData.CourseID;
                this.$refs["update-session-modal"].show();
            },
            toggleAll(checked, subProgramID) {
                let vm = this;
                if (checked && this.indeterminateComputed[subProgramID]) {
                    vm.UserList.forEach(function (user) {
                        if (user.SubProgramID == subProgramID) {
                            user.Checked = true;
                        }
                    });
                }
                else if (vm.UserList.some(e => e.Checked != true && e.SubProgramID == subProgramID)) {
                    vm.UserList.forEach(function (user) {
                        if (user.SubProgramID == subProgramID) {
                            user.Checked = true;
                        }
                    });
                }
                else if (vm.UserList.some(e => e.Checked != false && e.SubProgramID == subProgramID)) {
                    vm.UserList.forEach(function (user) {
                        if (user.SubProgramID == subProgramID) {
                            user.Checked = false;
                        }
                    });
                }
            },
            CancelModal(modalRef) {
                this.$refs[modalRef].hide();
            },
            formatDate(value, fmt = 'D MMM YYYY : hh:mm A') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DDThh:mm:ss').format(fmt)
            },
            formatDateMonthDayYear(value, fmt = 'MMM D YYYY : hh:mm A') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DDThh:mm:ss').format(fmt)
            },
            SessionPhotoImages(index) {
                if (this.SessionPhotos.length != 0)
                    return this.SessionPhotos[index].ImageURL;
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
            UpdateStatus(rowData) {
                this.$MasterAPI.ExecuteRequest("POST", "Training/UpdateAttendee", { Id: rowData.Id, EmployeeID: rowData.EmployeeID, CertificateFileID: rowData.CertificateFileID, Status: this.AttendeeEdit.Status[rowData.Id] }, () => { }, () => { }, false);
            },
        },
        components: {
            Vuetable,
            flatPickr,
            ActionButtonWithIcon,
            EditMode,
            DocumentViewer,
        },
        computed: {
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            UserPrivateProfile: function () {
                return this.$store.state.User.PrivateProfile;
            },
            indeterminateComputed: function () {
                let output = {};
                let vm = this;
                let noneSelected = true;
                if (!vm.UserList) {
                    return false;
                }
                vm.SubProgramList.forEach(function (subProgram) {

                    vm.subProgramSelected.allSelected[subProgram.Id] = true;
                    let hasCheck = false;
                    let hasUncheck = false;
                    vm.UserList.forEach(function (user) {
                        if (user.SubProgramID == subProgram.Id) {
                            if (user.Checked) {
                                hasCheck = true;
                                noneSelected = false;
                            }
                            else {
                                hasUncheck = true;
                                vm.subProgramSelected.allSelected[subProgram.Id] = false;
                            }
                        }
                        
                    });
                   
                    if (noneSelected == true) {
                        vm.subProgramSelected.allSelected[subProgram.Id] = false;
                    }
                    output[subProgram.Id] = (hasCheck == hasUncheck);
                });
                return output;
            }
            //SessionPhotoImages: function (index) {
            //    console.log(index);
            //    if (this.SessionPhotos.length != 0)
            //        return this.SessionPhotos[index].ImageURL;
            //    //let upp = this.UserPrivateProfile;
            //    //if (upp.UserId != '') {
            //    //    if (upp.data != null) {
            //    //        return upp.data.SignatureURL;
            //    //    }
                    
            //    //} else {
            //    //    return '';
            //    //}
            //}
        },
        mounted() {
            this.GetSubPrograms();
            //this.GetSessions();
            this.GetCourses();
            this.GetUsers();

        }
    }
</script>

<style scoped>
    .btn-olive-green {
        background-color: #94A545 !important;
        color: white;
        box-shadow: none;
    }
    /deep/ .EditDiv {
        position:relative !important;
        bottom:0px !important; 
        z-index: 0 !important;
        align-self:start !important;
        padding:0 !important;
        padding-left:1rem !important;
    }
    /deep/ .EditRowDiv{
        height:0 !important;
        float: left !important;
    }
</style>